import { connect } from 'react-redux'
import { actionUpdateProductHfss } from './store'
import ProductHfssUpdateForm from './Form'

const mapDispatchToProps = {
  updateProductHfss: actionUpdateProductHfss,
}

export default connect(null, mapDispatchToProps)(ProductHfssUpdateForm)
